<template>
  <div class="first-Bar">
    <router-link
      class="text-first-card"
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: list[2].url } })"
    >
      {{ list[2].title }}
    </router-link>
    <div class="cards-6" :class="{ 'cards-7': list.length === 7 }">
      <router-link
        v-for="(item, index) in list"
        :key="index"
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="card"
        :style="`grid-area: card-${index + 1}`"
      >
        <div class="image-block">
          <span class="category">{{ item.sub_category.name }}</span>
          <ImageContainer
            :src="item.image.medium"
            :alt="item.title"
            :thumb="item.image.thumbnail"
            class="image"
          />
        </div>
        <div class="about">
          <h2 class="category-about category">{{ item.sub_category.name }}</h2>
          <h1 class="text">
            {{ item.title }}
          </h1>
          <h2 class="time">
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h2>
          <span class="decor-line-bottom"></span>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FirstBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.first-Bar {
  margin: 2rem 0;
  position: relative;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 90%;
  
  .text-first-card {
    position: relative;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 3em;
    line-height: 1.1;
    color: #ffffff;
    --snup: 2;
    display: -webkit-box;
    -webkit-line-clamp: var(--snup);
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding-right: 25%;
    color: var(--primary-font-color);
    text-transform: capitalize;
    margin-bottom: 1rem;
  }
  .cards-6 {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-areas:
      "card-1 card-1 card-1 card-3 card-3 card-3 card-4 card-4"
      "card-1 card-1 card-1 card-3 card-3 card-3 card-5 card-5"
      "card-2 card-2 card-2 card-3 card-3 card-3 card-6 card-6"
      "card-2 card-2 card-2 card-3 card-3 card-3 card-7 card-7";
    grid-row-gap: 1em;
    position: relative;
    .card {
      position: relative;
      display: flex;
      .image-block {
        position: relative;
        width: 100%;
        display: none;
        .image {
          position: relative;
          width: 100%;
          // aspect-ratio: 4/3;
          padding-bottom: 75%;
          // height: 10px;
        }
        .category {
          position: absolute;
          top: 0;
          left: 0;
          background-color: var(--secondary-font-color);
          padding: 0.5% 1%;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 2em;
          line-height: 1.4;
          color: var(--category-color);
          z-index: 1;
          text-transform: capitalize;
        }
      }
      .about {
        position: relative;
        margin-top: 0.4rem;
        margin-left: 1rem;
        display: flex;
        flex-direction: column;
        font-size: 2.5em;
        .category-about {
          position: relative;
          color: var(--category-color);
          margin-bottom: 2%;
        }
        .text {
          --snup: 2;
          display: -webkit-box;
          -webkit-line-clamp: var(--snup);
          -webkit-box-orient: vertical;
          overflow: hidden;
          position: relative;
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          line-height: 1.25;
          color: var(--primary-font-color);
          text-transform: capitalize;
          font-size: 1.08em;
          line-height: 1.4em;
        }
        .time {
          position: relative;
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          line-height: 1;
          color: var(--date-color);
          opacity: 0.6;
          padding-top: 0.6rem;
          font-size: 0.89em;
        }
        .decor-line-bottom {
          position: relative;
          width: 100%;
          height: 1px;
          margin-top: 5%;
          background: var(--primary-font-color);
        }
      }
      &:nth-child(1),
      &:nth-child(2) {
        align-self: center;
        .image-block {
          display: block;
          .image {
            // aspect-ratio: 3/2;
            padding-bottom: 66%;
          }
        }
        .about {
          padding: 0 3% 0 1.5%;
          width: 70%;
          justify-content: space-between;
          margin-top: 0;
          .category-about {
            display: none;
          }
          .text {
            --snup: 4;
          }
          .decor-line-bottom {
            display: none;
          }
        }
      }
      &:nth-child(3) {
        align-self: center;
        .image-block {
          display: block;
          padding: 0 3% 2% 0;
          .image {
            // aspect-ratio: 55/48;
            // height: 10vw;
            padding-bottom: 90%;
          }
        }
        .about {
          display: none;
        }
      }
      &:nth-child(7) {
        .decor-line-bottom {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .first-Bar {
    width: 90%;
    .text-first-card {
      font-size: 2.5em;
    }
    .cards-6 {
      .card {
        .image-block {
          .category {
            font-size: 1.4em;
          }
        }
        .about {
          margin-left: 0;
          font-size: 1.4em;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .first-Bar {
    width: var(--main-wrapper-width);
    .text-first-card {
      font-size: 2.5em;
    }
    .cards-6 {
      .card {
        .image-block {
          .category {
            font-size: 1em;
          }
        }
        .about {
          margin-left: 0;
          font-size: 1.11em;
          width: 100%;
          .time {
            font-size: 0.9em;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .first-Bar {
    margin: 1rem 0;
    .text-first-card {
      display: none;
    }
    .cards-7 {
      grid-template-areas:
        "card-1 card-1 card-1 card-1 . card-2 card-2 card-2 card-2"
        ". card-3 card-3 card-3 card-3 card-3 card-3 card-3 ."
        ". card-4 card-4 card-4 card-4 card-4 card-4 card-4 ."
        ". card-5 card-5 card-5 card-5 card-5 card-5 card-5 ."
        "card-6 card-6 card-6 card-6 . card-7 card-7 card-7 card-7" !important;
      .card {
        &:nth-child(6),
        &:nth-child(7) {
          flex-direction: column;
          .image-block {
            .category {
              padding: 1% 1.5% !important;
            }
            .image {
              max-width: inherit !important;
            }
          }
          .about {
            margin-top: 0.4rem !important;
            padding: 0 !important;
            width: 100% !important;
            .text {
              --snup: 3 !important;
            }
          }
        }
      }
    }
    .cards-6 {
      grid-template-columns: repeat(9, 1fr);
      grid-template-areas:
        "card-1 card-1 card-1 card-1 . card-2 card-2 card-2 card-2"
        ". card-3 card-3 card-3 card-3 card-3 card-3 card-3 ."
        ". card-4 card-4 card-4 card-4 card-4 card-4 card-4 ."
        ". card-5 card-5 card-5 card-5 card-5 card-5 card-5 ."
        ". card-6 card-6 card-6 card-6 card-6 card-6 card-6 .";
      grid-row-gap: 2em;

      .card {
        flex-direction: row;
        align-self: start !important;
        .image-block {
          display: block;
          padding: 0 !important;
          width: auto !important;
          .image {
            // aspect-ratio: 4/3 !important;
            padding-bottom: 75%;
            min-width: 242px;
            max-width: 242px;
          }
          .category {
            padding: 1% 3%;
            display: block;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 0.93em;
          }
        }
        .about {
          padding: 0 0 0 2%;
          font-size: 1.06em;
          display: flex !important;
          justify-content: space-between;
          margin-top: 0;
          .text {
            --snup: 5;
            line-height: 1.4;
            margin: auto 0;
          }
          .category-about {
            display: none;
          }
          .decor-line-bottom {
            display: none;
          }
          .time {
            font-size: 0.85em;
          }
        }
        &:nth-child(1),
        &:nth-child(2) {
          flex-direction: column;
          .image-block {
            .category {
              padding: 1% 1.5%;
            }
            .image {
              max-width: inherit;
            }
          }
          .about {
            margin-top: 0.4rem;
            padding: 0;
            width: 100%;
            .text {
              --snup: 3;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .first-Bar {
    .cards-6 {
      .card {
        .image-block {
          width: auto !important;
          .image {
            min-width: none !important;
            max-width: 242px !important;
          }
        }
        .about {
          font-size: 1.2em;
          .text {
            --snup: 3 !important;
          }
        }
        &:nth-child(1),
        &:nth-child(2) {
          .image-block {
            .image {
              min-width: inherit !important;
            }
          }
        }
        .category {
          font-size: 0.8em;
        }
      }
    }
    .cards-7 {
      .card {
        &:nth-child(6),
        &:nth-child(7) {
          .image-block {
            .image {
              min-width: inherit !important;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .first-Bar {
    margin: 0.5rem 0;
    width: 100% !important;
    .cards-6 {
      grid-template-columns: repeat(2, 1fr);
      grid-template-areas:
        "card-1 card-1"
        "card-1 card-1"
        "card-2 card-2"
        "card-2 card-2"
        "card-3 card-3"
        "card-3 card-3"
        "card-3 card-3"
        "card-3 card-3"
        "card-4 card-4"
        "card-5 card-5"
        "card-6 card-6"
        "card-7 card-7" !important;
      grid-row-gap: 1em;
      .card {
        flex-direction: column;
        margin: 0 10px;
        .image-block .category {
          font-size: 0.72em;
        }
        .image-block {
          display: none !important;
          .image {
            min-width: none !important;
            max-width: none !important;
          }
        }
        .about {
          padding: 0;
          .category-about {
            display: block !important;
            padding-left: 5%;
            font-size: 10px;
          }
          .text {
            --snup: 2 !important;
            padding: 0 5%;
            font-size: 14px;
          }
          .time {
            padding-left: 5%;
            font-size: 0.66em;
          }
          .decor-line-bottom {
            display: block;
          }
        }
        &:nth-child(1),
        &:nth-child(2) {
          flex-direction: row;
          .image-block {
            display: block !important;
            width: 100% !important;
          }
          .about {
            padding-left: 2%;
            margin-top: 0;

            .category-about {
              display: none !important;
              padding: 0;
            }
            .text {
              --snup: 4 !important;
              padding: 0;
              font-size: 12px;
              height: 100%;
            }
            .time {
              padding: 0;
            }
            .decor-line-bottom {
              display: none;
            }
          }
        }
        &:nth-child(3) {
          padding: 0 5%;
          .image-block {
            display: block !important;
            .category{
              padding: 0.25rem;
            }
          }
          .about {
            padding: 1% 5% 0 5%;
            text-align: center;
            .category-about {
              display: none !important;
            }
            .decor-line-bottom {
              display: none;
            }
          }
        }

        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
          .about {
            .category-about {
              font-size: 0.8em !important;
            }
          }
        }
      }
    }
  }
}
</style>
